import React from 'react';
import { Star } from 'lucide-react';
import styles from './ui-stars.module.scss';

interface UIStarsProps {
    rating: number;
    size?: 'sm' | 'md' | 'lg';
    count?: number;
    className?: string;
}

const sizeMap = { sm: 14, md: 18, lg: 22 };

export function UIStars({
    rating,
    size = 'md',
    count,
    className = '',
}: UIStarsProps) {
    const iconSize = sizeMap[size];
    const stars = [];

    for (let i = 1; i <= 5; i++) {
        const filled = i <= Math.round(rating);
        stars.push(
            <Star
                key={i}
                size={iconSize}
                className={filled ? styles.filled : styles.empty}
                fill={filled ? 'var(--gf-star)' : 'none'}
                strokeWidth={filled ? 0 : 1.5}
            />
        );
    }

    return (
        <span className={`${styles.stars} ${styles[`size-${size}`]} ${className}`}>
            <span className={styles.icons}>{stars}</span>
            {count !== undefined && (
                <span className={styles.count}>({count})</span>
            )}
        </span>
    );
}

export default UIStars;
